/**
 * Comm Center vocabulary shared by the adapters and the UI.
 *
 * The categories drive the filter chips of the Activities tab; the types drive
 * the icon and the colour of the leading circle of a card. Both are derived
 * from `ActivityType` / `ActivityStatus` of the API in adapters.js.
 */

export const ACTIVITY_CATEGORIES = {
    COMMENTS: 'comments',
    COMPLETED: 'completed',
    EDITS: 'edits',
    TEAM: 'team',
    DEADLINES: 'deadlines',
};

export const ACTIVITY_TYPES = {
    COMMENTS: 'comments',
    CUE_UPDATED: 'cue_updated',
    CUE_ASSIGNED: 'cue_assigned',
    CUE_COMPLETED: 'cue_completed',
    TEAM_INVITED: 'team_invited',
    TEAM_JOINED: 'team_joined',
    DEADLINE: 'deadline',
};

/**
 * Inbound channels a communication can arrive from (`MessageSource` minus
 * `in_app`, which is the default and carries no badge).
 */
export const COMMENT_SOURCE_LABELS = {
    whatsapp: 'whatsapp',
    telegram: 'telegram',
    email: 'mail',
};
